

export function RenderHelp() {
    return (
		<iframe src={"https://data.cloud-backend.com/help.html"}
				frameborder={"0"} border={"0"} cellspacing={"0"}
				style={{ "boxShadow":"0.0px", "width":"100%", "height":"40rem", "overflow":"hidden"}} />
	)
}
